export enum MeasurementType {
  AREA = "area",
  PERIMETER = "perimeter",
}

export enum MetricArea {
  SQ_METER = "sq.m.",
  HECTARE = "hectare",
}

export enum ImperialArea {
  SQ_FEET = "sq.ft.",
  ACRE = "acre",
}

export enum MetricPerimeter {
  METERS = "meter",
  KILOMETER = "kilometer",
}

export enum ImperialPerimeter {
  FEET = "feet",
  MILES = "miles",
}

export type AreaTypes = MetricArea | ImperialArea;

export type PerimeterTypes = MetricPerimeter | ImperialPerimeter;
